export const applianceConfigurationOptions = [
  'device-attributes',
  'jumphost',
  'oui',
  'discovery',
  'discovery-seeds',
  'device-credentials',
  'assurance-engine',
  'discovery-tasks',
  'vendors-api',
  'site-separation',
  'cli-settings',
  'bgp-routing',
  'snapshot-retention',
  'configuration-management',
  'api-tokens',
  'webhooks',
  'snmp',
  'certificates',
  'local-users',
  'ldap',
  'roles',
  'policies',
  'intent-checks',
  'dashboards-and-widgets',
  'manual-links',
  'labels',
  'aim',
  'table-data',
  'graph-data',
  'discovery-history',
] as const;

export type ConfigurationOptionKey =
  (typeof applianceConfigurationOptions)[number];

export type ConfigurationOptionParent =
  | 'device-and-discovery'
  | 'global-configuration'
  | 'discovery-settings'
  | 'integration'
  | 'system'
  | 'administration';

export type ApplianceConfigurationTreeItem =
  | {
      type: 'leaf';
      key: ConfigurationOptionKey;
      label: string;
      disabled?: boolean;
      description?: string;
    }
  | {
      type: 'parent';
      key: ConfigurationOptionParent;
      label: string;
      children: ApplianceConfigurationTreeItem[];
      disabled?: boolean;
      description?: string;
    };
